export const getIsOtpChannel = (value) => value === "sms" || value === "whatsapp";
//# sourceMappingURL=getIsOtpChannel.js.map